import { createActions } from 'redux-actions';

const TOGGLE_SPINNER = 'TOGGLE_SPINNER';

const actionOptions = {
  prefix: 'app/spinner',
};

export const actions = createActions({}, TOGGLE_SPINNER, actionOptions);

export const toggleSpinner = payload => {
  return {
    type: `${actionOptions.prefix}/${TOGGLE_SPINNER}`,
    payload,
  };
};
